import React, { useState, useRef, useEffect, useContext } from 'react'
import Link from 'next/link'
import Head from 'next/head'
import { useRouter } from 'next/router'

import { HistoryManagerContext } from 'components/hooks/HistoryManagerProvider'
import { Button, Modal, ErrorIcon } from 'components/common'
import { getProfileInfo, login, setServiceAddressDetails } from 'actions'
import s from './Login.module.css'
import {
  useAppDispatch,
  useAppSelector
} from 'components/hooks/redux-selectors'
import { ModalRef } from 'components/common/Modal/Modal'

const Login = () => {
  const { error, isLoading } = useAppSelector((state) => state.auth)
  const history = useContext(HistoryManagerContext)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const getRedirectUrl = () => {
    return localStorage.getItem('redirectUrlUsedWhenTokenIsNotValid') || '';
  };

  const errorModalRef = useRef<ModalRef>(null)

  const [emailInput, setEmailInput] = useState('')
  const [passwordInput, setPasswordInput] = useState('')

  const dispatch = useAppDispatch()

  const router = useRouter()

  const loginHandler = (e) => {
    e.preventDefault()

    dispatch(
      login(
        emailInput,
        passwordInput,
        () => {
          const redirectUrl = getRedirectUrl();
          if (redirectUrl !== '') {
             router.push(redirectUrl)
              return;
          }
          if (history.length > 1 && history[history.length - 2].includes('/register')) {
              router.push('/');
              return;
          }
          if (
            history.length > 2 &&
            history[history.length - 2].includes('isPrivate=1')
          ) {
            router.push(history[history.length - 2])
            return
          }
          if (history.length > 1) {
            if (history[history.length - 2] === '/login') {
              router.push('/')
              return
            } else {
              router.push(history[history.length - 2])
            }
          } else {
            router.push('/')
          }
        },
        () => {
          errorModalRef.current!.openModal()
          setPasswordInput('')
        }
      )
    )
  }

  return (
    <div className="content">
      <Head>
        <title>
          Login and start a CaribeEats delivery order in St. Kitts, Nevis,
          Grenada, Dominica
        </title>
        <meta
          name="description"
          content="Login and start a CaribeEats delivery order in St. Kitts, Nevis,
          Grenada, Dominica"
        ></meta>
      </Head>

      <form className={s.form} onSubmit={loginHandler}>
        <input
          type="email"
          value={emailInput}
          onChange={(e) => setEmailInput(e.target.value)}
          className={s.input}
          placeholder="E-mail"
          required
        />

        <input
          type="password"
          className={s.input}
          value={passwordInput}
          onChange={(e) => setPasswordInput(e.target.value)}
          placeholder="Password"
          required
        />

        <Button text="LOGIN" type="submit" isLoading={isLoading} />

        <Link href="/forgotPassword">
          <a className={s.forgotText}>I forgot my password</a>
        </Link>

        <Link href="/register">
          <a className={s.registerText}>
            Don't have an account?{' '}
            <span style={{ color: 'blue' }}>Sign Up</span>
          </a>
        </Link>

        <Modal ref={errorModalRef} className="errorModalWrapper">
          <ErrorIcon className="errorIcon" />

          <div className="errorInfo">{error}</div>
        </Modal>
      </form>
    </div>
  )
}

export default Login
